namespace $.$$ {
	export class $shm_period extends $.$shm_period {

		@ $mol_mem
		date_from( next?: string ): string {
			return this.period( next ? {from: next, to: this.date_to()} : undefined ).from ?? ''
		}

		@ $mol_mem
		date_to( next?: string ): string {
			return this.period( next ? {to: next, from: this.date_from()} : undefined ).to ?? ''
		}
		
		@ $mol_mem
		period_str( next?: string ): string {
			if( next === '' ) {
				this.clear()
				return ''
			}
			if( next ) {
				const dates = next.match( /\d{4}-\d{2}-\d{2}|\d{2}\.\d{2}\.\d{4}/g ) ?? []
				const [from, to] = dates.map( date => this.$.$shm_date.iso( date ) )
				if( !from || !to ) return next
				this.period( {from, to} )
				return next
			}
			const from = this.date_from()
			const to = this.date_to()
			return (from && to) ? this.$.$shm_date.text( from ) + ' – ' + this.$.$shm_date.text( to ) : ''
		}

		clear() {
			this.date_from('')
			this.date_to('')
		}
		
	}
}
